import { SET_VISIBILITY } from "./types";

// Change visibility of sidebar
export function changeSidebarVisibility(visibility) {
  return {
    type: SET_VISIBILITY,
    visibility,
  };
}
